import classnames from 'classnames';

import styles from './styles.module.less';

const open = (url: any) => {
  window.open(url);
};
const Shuiwu = () => {
  return (
    <div className={classnames(styles['container'])}>
      <div className={classnames(styles['background'])}>
        <div className={classnames(styles['background-bg'])}></div>
      </div>
      <div
        className={classnames(styles['foreground'])}
        style={{ position: 'relative' }}
      >
        <div className={classnames(styles['title'])}>
          关于涉税报送的重要通知
        </div>
        <div className={classnames(styles['content'])}>
          <div>
            2025年6月20日国务院发布
            <span className={classnames(styles['blue-text'])} onClick={() => open('https://fgk.chinatax.gov.cn/zcfgk/c100010/c5241238/content.html')}>
              《
              <span className={classnames(styles['underline-text'])}>
                互联网平台企业涉税信息报送规定
              </span>
              》
            </span>
            （国务院令第810号），明确了平台企业报送平台内经营者和从业人员涉税信息的义务；2025年6月26日国家税务总局发布
            <span className={classnames(styles['blue-text'])} onClick={() => open('https://fgk.chinatax.gov.cn/zcfgk/c100012/c5241477/content.html')}>
              《
              <span className={classnames(styles['underline-text'])}>
                关于互联网平台企业报送涉税信息有关事项的公告
              </span>
              》
            </span>
            （国家税务总局公告2025年第15号）
            ，对平台企业涉税信息报送作出具体要求。
          </div>
          <div>
            根据上述规定，本平台将于2025年10月首次报送平台内经营者和从业人员的身份信息，以及2025年第三季度（7月至9月）的收入信息（2025年第三季度以前的收入信息无需报送）。后续将在每个季度终了的次月内（1月、4月、7月、10月）报送平台内经营者和从业人员的身份信息以及上季度收入信息。税务机关依法开展税务检查或者发现您（单位）有涉税风险时，平台还将根据税务机关的要求提供您（单位）的合同订单、交易明细、资金账户、物流等明细涉税信息。
          </div>
          <div>
            平台内经营者和从业人员可以通过平台指定查询路径查看平台报送您（单位）的涉税信息；如发现平台报送的数据有误，可将相关情况通过平台客服进行反馈。
          </div>
          <div>
            依法纳税是法定义务，为帮助平台内经营者和从业人员合规经营，依法履行纳税义务，减少涉税风险，平台提示您（单位）：
          </div>
          <div>
            一是依法办理市场主体登记。按照《电子商务法》第10条、《网络交易监督管理办法》（国家市场监督管理总局令第37号）第8条规定，除个人销售自产农副产品、家庭手工业品，以及利用自己的技能从事依法无须取得许可的便民劳务活动外，平台内经营者年交易额累计超过10万元的，应当依法办理市场主体登记。个人办理个体工商户登记的，应当按照《个体工商户登记管理规定》（国家市场监督管理总局令第103号）规定，在经营场所所在地或住所所在地登记注册，不得接受平台违规指定地点注册。
          </div>
          <div>
            二是依法办理税务信息确认。平台内经营者在市监部门办理市场主体登记后，市监部门将登记信息与税务部门实时共享，经营者无需另行办理税务登记证件。平台内经营者首次发生纳税义务后，应当到税务机关办理信息确认，并按规定连续按期纳税申报。
          </div>
          <div>
            三是依法办理纳税申报。平台内经营者和从业人员应当如实汇总在各平台及线下其他渠道取得的全部应税收入，按规定时限完成纳税申报。若未如实纳税申报，将承担相应的法律责任。
          </div>
          <div>
            平台依法为从业人员取得的劳务报酬代扣代缴个税，从业人员应当按规定在次年汇算清缴期间办理个税汇算清缴。
          </div>
          <div>
            四是依法办理增值税一般纳税人登记。平台内经营者年应税销售额（连续12个月或四个季度的销售额）超过500万元的，应当及时向主管税务机关申请登记为一般纳税人，按照适用税率纳税申报。如果没有按规定登记为一般纳税人，未来可能会被税务机关按照一般计税方法追缴税款及滞纳金。
          </div>
          <div>
            五是不得分拆收入少缴税款。平台内经营者和从业人员不得将本应归属于同一纳税主体的收入，通过变更店铺经营主体、关联交易、更换提现账号等方式，分散至多个纳税主体。违规分拆收入偷逃税款的，税务机关将依法追缴税款、滞纳金并进行处罚。
          </div>
          <div>
            本平台将于2025年10月向主管税务机关报送您（单位）的身份信息和2025年第三季度的收入信息。依法纳税是您（单位）应尽的义务，请高度重视税务合规，务必如实汇总在各平台以及线下其他渠道取得的全部应税收入，按税收法律法规要求的时限和内容进行纳税申报，否则将承担相应的法律责任。
          </div>
        </div>
        <div className={classnames(styles['date'])}>
          日期：2025 年 9 月 30 日
        </div>
      </div>
    </div>
  );
};

export default Shuiwu;
